export interface GuestCartItem {
  productVariantId: string;
  quantity: number;
}

function getGuestCartKey(): string {
  if (typeof window === 'undefined') return 'guest_cart';
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const config = require('@/lib/api-adapter/config').getCurrentConfig();
    const storeId = config?.storeId || config?.storeKey;
    return storeId ? `guest_cart_${storeId}` : 'guest_cart';
  } catch {
    return 'guest_cart';
  }
}

export function readGuestCart(): GuestCartItem[] {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(localStorage.getItem(getGuestCartKey()) || '[]');
  } catch {
    return [];
  }
}

export function writeGuestCart(items: GuestCartItem[]): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(getGuestCartKey(), JSON.stringify(items));
}

export function clearGuestCart(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(getGuestCartKey());
}

export function addToGuestCart(variantId: string, quantity: number): GuestCartItem[] {
  const items = readGuestCart();
  const existing = items.find((i) => i.productVariantId === variantId);
  if (existing) {
    existing.quantity += quantity;
  } else {
    items.push({ productVariantId: variantId, quantity });
  }
  writeGuestCart(items);
  return items;
}

export function updateGuestCartItem(variantId: string, quantity: number): GuestCartItem[] {
  const items = readGuestCart().map((i) =>
    i.productVariantId === variantId ? { ...i, quantity } : i
  );
  writeGuestCart(items);
  return items;
}

export function removeFromGuestCart(variantId: string): GuestCartItem[] {
  const items = readGuestCart().filter((i) => i.productVariantId !== variantId);
  writeGuestCart(items);
  return items;
}

export function getGuestCartCount(): number {
  return readGuestCart().reduce((sum, item) => sum + item.quantity, 0);
}
